import { Component, OnInit, Input } from '@angular/core';

import { RevealContentStates } from '@finder/shared/components/reveal-content/reveal-content.constants';
import { HEADERS_DEEP_LINKS } from '@finder/shared/constants/app.constants';
import { SamplePackage } from './sample-packages.interface';
import { PolylineComponent } from '../polyline/polyline.component';
import { PackageCardComponent } from '../package-card/package-card.component';
import { RevealContentComponent } from '../reveal-content/reveal-content.component';
import { ScrollToDirective } from '@finder/shared/directives/scroll-to/scroll-to.directive';
import { CommonModule } from '@angular/common';
import { MultipleItemsPerRowDirective } from '@finder/shared/directives/multiple-items-per-row/multiple-items-per-row.directive';
import { AlignHeaderDirective } from '@finder/shared/directives/align-text/align-header.directive';

@Component({
    selector: 'finder-sample-packages',
    templateUrl: './sample-packages.component.html',
    styleUrls: ['./sample-packages.component.scss'],
    standalone: true,
    imports: [
        AlignHeaderDirective, // finderAlignHeader
        CommonModule,
        MultipleItemsPerRowDirective, // finderMultipleItemsPerRow
        PackageCardComponent,
        PolylineComponent,
        RevealContentComponent,
        ScrollToDirective,
    ]
})
export class SamplePackagesComponent implements OnInit {

    @Input() packagesData: SamplePackage;

    minimumLength: number;
    limit: number;
    showMoreText: string;
    showLessText: string;
    cardCount: number;
    deepLink: string;
    protected maxItemsPerRow: number;

    constructor() {
        this.deepLink = HEADERS_DEEP_LINKS.packageCards;
    }

    ngOnInit() {
        this.showMoreText = this.packagesData?.ctaLinks?.showMore?.title;
        this.showLessText = this.packagesData?.ctaLinks?.showLess?.title;
        this.cardCount = this.packagesData.packages.length;
        this.maxItemsPerRow = this.packagesData.maxItemsPerRow ?? 4;
        const initialVisibleRowsNumber = this.packagesData.initialVisibleRowsNumber ?? 1;
        this.minimumLength = this.maxItemsPerRow * initialVisibleRowsNumber;
        this.limit = this.minimumLength;
    }

    /**
     * @name        focusOnReveal
     * @description pick the last card children and focus the current card face title.
     * @param       element {Event} event emitted from (finderElementChange) directive, contains the element that has changed.
     */
    focusOnReveal(element) {
        if (element.childElementCount > this.minimumLength + 1) {
            element.children[this.minimumLength].querySelector('.front-title').focus();
        }
    }

    revealContent(state: RevealContentStates) {
        this.limit = state === RevealContentStates.LESS ? this.packagesData.packages.length : this.minimumLength;
    }
}
